import styled from 'styled-components';

export const Icon = styled.img`
  display: none;
  position: absolute;
  left: 17px;
  top: -10px;
  transition: none;
  animation: blinker 1s step-end infinite;

  @keyframes blinker {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }
`;

export const Content = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  --box-shadow-color: ${(props) => {
    switch (props.type) {
      case 'high':
        return 'rgba(255, 0, 0, 1)';
      case 'medium':
        return 'rgba(255, 131, 34, 1)';
      case 'low':
      default:
        return 'rgba(217, 201, 105, 1)';
    }
  }};
  box-shadow: 0px 0px 13px 2px var(--box-shadow-color) inset;
  z-index: 2;
  pointer-events: ${(props) => (props.$active ? 'auto' : 'none')};
`;
